module.exports = __webpack_public_path__ + "img/proapp-4.9215cb2b.jpg";